import React, { useState, useEffect } from "react";
import { Grid, Box } from "@mui/material";
import CompanySelect from "../CommonComponents/CompanySelect";
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "../CommonComponents/RightDrawer";
import Cookies from "js-cookie";
import { formatDate } from "../../utils/commonutils";
import GlobalTimePicker from "../CommonComponents/Timeinput";
import { MasterAutocomplete } from "../CommonComponents/MasterSelect";
import {
  FALLBACK_COMMUNICATION_CHANNEL,
  FALLBACK_COMMUNICATION_RELATED,
  FALLBACK_COMMUNICATION_TYPE,
} from "../../utils/masterFallbacks";
import AttachmentPanel from "../CommonComponents/AttachmentPanel";

const CommunicationModal = ({
  isOpen,
  mode,
  onClose,
  onSubmit,
  communicationData,
  customerData
}) => {
  const ID = Cookies.get("ClidToken");
  const [formData, setFormData] = useState({
    date: "",
    time: "12:00 AM",
    type: "",
    channel: "",
    relatedTo: "",
    name: "",
    subject: "",
    customerId: null,
    sentBy: ID || null,
  });

  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    setFormData({
      date: formatDate(communicationData?.date) || "",
      time: communicationData?.time || "12:00 AM",
      type: communicationData?.type || "",
      channel: communicationData?.channel || "",
      relatedTo: communicationData?.relatedTo || "",
      name: communicationData?.name || "",
      subject: communicationData?.subject || "",
      customerId: communicationData?.customerId || null,
      sentBy: ID || null,
    });
    setErrors([]);
  }, [isOpen, communicationData, ID]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (e, val, field) => {
    setFormData((prev) => ({ ...prev, [field]: val }));
  };

  const handleSubmit = () => {
    const required = [
      "date",
      "time",
      "type",
      "channel",
      "relatedTo",
      "name",
      "subject",
      "customerId",
    ];

    const missing = required?.filter((f) => !formData[f]);
    if (missing.length > 0) {
      setErrors(missing);
      return;
    }

    onSubmit(formData);
    onClose();
  };
  return (
    <Modal className="all-modals" isOpen={isOpen} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose} kicker="Communication">
        {mode === "add" ? "Log communication" : "Edit communication"}
      </ModalHeader>

      <ModalBody>
        <Grid container spacing={2}>
          {/* Date */}
          <Grid item xs={12} sm={6}>
            <p className="small-text">Date</p>
            <input
              className="input-main"
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
            />
            {errors.includes("date") && (
              <p className="error-message">Date shouldn't be empty</p>
            )}
          </Grid>

          {/* Time */}
          <Grid item xs={12} sm={6}>
                        <p className="small-text">Time</p>

             <GlobalTimePicker
    value={
      formData.time
        ? {
            hour: formData.time.split(" ")[0]?.split(":")[0] || "12",
            minute: formData.time.split(" ")[0]?.split(":")[1] || "00",
            ampm: formData.time.split(" ")[1] || "AM",
          }
        : { hour: "12", minute: "00", ampm: "AM" }
    }
    onChange={(val) => {
      setFormData((prev) => ({
        ...prev,
        time: val,
      }));
    }}
  />

          
            {errors.includes("time") && (
              <p className="error-message">Time shouldn't be empty</p>
            )}
          </Grid>

          {/* Type */}
          <Grid item xs={12} sm={6}>
            <p className="small-text">Type</p>
            <MasterAutocomplete
              group="communication_type"
              fallback={FALLBACK_COMMUNICATION_TYPE}
              value={formData.type}
              onChange={(e, val) => handleDropdownChange(e, val, "type")}
              placeholder="Select type"
            />
            {errors.includes("type") && (
              <p className="error-message">Type shouldn't be empty</p>
            )}
          </Grid>

          {/* Channel */}
          <Grid item xs={12} sm={6}>
            <p className="small-text">Channel</p>
            <MasterAutocomplete
              group="communication_channel"
              fallback={FALLBACK_COMMUNICATION_CHANNEL}
              value={formData.channel}
              onChange={(e, val) => handleDropdownChange(e, val, "channel")}
              placeholder="Select channel"
            />
            {errors.includes("channel") && (
              <p className="error-message">Channel shouldn't be empty</p>
            )}
          </Grid>

          {/* Related To */}
          <Grid item xs={12} sm={6}>
            <p className="small-text">Related To</p>
            <MasterAutocomplete
              group="communication_related_to"
              fallback={FALLBACK_COMMUNICATION_RELATED}
              value={formData.relatedTo}
              onChange={(e, val) => handleDropdownChange(e, val, "relatedTo")}
              placeholder="Select related type"
            />
            {errors.includes("relatedTo") && (
              <p className="error-message">Related To shouldn't be empty</p>
            )}
          </Grid>

          {/* Name */}
          <Grid item xs={12} sm={6}>
            <p className="small-text">Name</p>
            <input
              className="input-main"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter name"
            />
            {errors.includes("name") && (
              <p className="error-message">Name shouldn't be empty</p>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <p className="small-text">Select Company</p>
            <CompanySelect
              options={customerData}
              value={formData.customerId}
              onChange={(val) => setFormData((prev) => ({ ...prev, customerId: val }))}
              placeholder="Select company"
            />
            {errors.includes("customerId") && (
              <p className="error-message">Company shouldn't be empty</p>
            )}
          </Grid>
          
          {/* Subject */}
          <Grid item xs={12} sm={8}>
            <p className="small-text">Subject</p>
            <textarea
              className="input-main textarea"
              rows={2}
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              placeholder="Subject"
            />
            {errors.includes("subject") && (
              <p className="error-message">Subject shouldn't be empty</p>
            )}
          </Grid>
        </Grid>
        {communicationData?._id && (
          <Box mt={3}>
            <AttachmentPanel moduleName="communication" recordId={communicationData._id} />
          </Box>
        )}
      </ModalBody>

      <ModalFooter>
        <Button className="btn btn-border" onClick={onClose}>
          Cancel
        </Button>
        <Button className="btn btn-colored" onClick={handleSubmit}>
          {mode === "add" ? "Save log" : "Save changes"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CommunicationModal;
